export default __webpack_public_path__ + "static/media/linkedInIcon.a448b649.png";